import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhatIsTrendrush from "./components/WhatIsTrendrush";
import HowItWorks from "./components/HowItWorks";
import ForRetailers from "./components/ForRetailers";
import ForConsumers from "./components/ForConsumers";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookiePolicy from "./components/CookiePolicy";

const Home = () => {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <WhatIsTrendrush />
        <HowItWorks />
        <div id="for-retailers">
          <ForRetailers />
        </div>
        <div id="for-consumers">
          <ForConsumers />
        </div>
        <div id="faq">
          <FAQ />
        </div>
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
